import { useCallback, useEffect, useState } from "react";
import { fetchProjects } from "../helper/projects";

const EMPTY_UNFILED = { exploration_count: 0, selection_count: 0, reproduction_count: 0 };

/**
 * The team's projects with their item counts, for the Projects page, the
 * project filter of the overview lists and the "Move to project" menu of the
 * cards. ``reload`` re-fetches (after a create, rename, delete or move).
 *
 * A failing request leaves an empty list: a page that lists items must not
 * break because the project lookup did.
 */
export default function useProjects() {
    const [state, setState] = useState({
        projects: [],
        unfiled: EMPTY_UNFILED,
        loading: true,
        error: null,
    });

    const reload = useCallback(async () => {
        try {
            const { projects, unfiled } = await fetchProjects();
            setState({ projects, unfiled, loading: false, error: null });
        } catch (error) {
            console.error("Loading the projects failed:", error);
            setState((old) => ({
                ...old, loading: false, error: "Loading the projects failed.",
            }));
        }
    }, []);

    useEffect(() => {
        let cancelled = false;
        // Through a promise chain: a stubbed API that returns no promise must
        // not throw out of the effect.
        Promise.resolve()
            .then(() => fetchProjects())
            .then(({ projects, unfiled }) => {
                if (!cancelled) setState({ projects, unfiled, loading: false, error: null });
            })
            .catch((error) => {
                console.error("Loading the projects failed:", error);
                if (!cancelled) {
                    setState((old) => ({
                        ...old, loading: false, error: "Loading the projects failed.",
                    }));
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return { ...state, reload };
}
